import React, { ChangeEvent, FC } from 'react'
import { InputText } from '../InputText'
import { useTrans } from '../../../../hooks/useTrans'
import styles from './SearchInput.module.css'
import cn from 'classnames'

type Props = {
  onChange: (e: ChangeEvent<HTMLInputElement>) => void
  className: string
}

export const SearchInput: FC<Props> = ({ onChange, className }) => {
  const { translate } = useTrans()
  const placeholder = translate('search_placeholder', 'Search...')

  return (
    <InputText
      iconLeft='search'
      className={cn(styles.input, className)}
      onChange={onChange}
      placeholder={placeholder}
    />
  )
}
